/*=========================================================================================
  File Name: gameGetters.js
  Description: game getters
==========================================================================================*/

export default {
  getCurrentLevelLimit: (state) => {
    try {
      // State is no value during loading screen.
      if (state.levels.length > 0) {
        return state.levels.filter((l) => l.level === state.currentLevel)[0];
      } else {
        return state;
      }
    } catch (e) {
      return {};
    }
  },
};
